import React from 'react'
import { useMutation } from 'jsonapi-react'
import { Star } from 'react-feather'
import { addCatererIdToMeta, getRequestedCatererIdsFromMeta, cityNameDecorator } from './dashboard-utils'
import posthog from 'posthog-js'
import styles from './LeadDashboardPage.module.css'
import logo from 'assets/svg/logo-bg.svg'

export default function TopMatches({ lead, loading, caterers }) {

  const requestedCatererIds = getRequestedCatererIdsFromMeta(lead)
  const failedCatererIds = []
  const [updateLead] = useMutation(['leads', lead.id, { token: lead.token }], {
    initialData: {},
  })

  if (!caterers?.length || loading) {
    return null
  }

  const addRequestedCatererToLead = (lead, caterer) =>{
    const meta = addCatererIdToMeta(lead, caterer.id)

    posthog.capture('vendor_quote_requested', { 
      vendor_name: caterer.name, 
      vendor_default_photo: !!(caterer.logo?.url || caterer.photo?.url), 
      vendor_rating: caterer.caterer_stat?.average_rating, 
      vendor_booking_count: caterer.caterer_stat?.total_bookings
    })

    return updateLead({id: lead.id, meta}).then(response => {
      if (response.data) {
        requestedCatererIds?.concat(caterer.id)
      } else {
        failedCatererIds.concat(caterer.id)
      }
    })
  }

  const lead_market = lead.address?.city_name

  return (
    <div className='container py-4'>
      <h1 className='text-3xl md:text-5xl font-platform text-black'>
        Top Vendors in {lead_market || 'Your Area'}
      </h1>
      <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4 py-4'>
        {caterers.map((caterer) => (
          <div className={[styles.card, 'mt-4 flex flex-col']} key={caterer.id}>
            
            {/* Card Header */}
            <div className='flex mb-4'>
              <a 
                className='border border-gray-400 rounded-md overflow-hidden'
                href={`/${caterer.slug}/`}
                target="_blank"
              >
                <img 
                  className='bg-cover h-0 bg-center'
                  style={{
                    width: '60px',
                    paddingTop:'100%', 
                    backgroundImage: `url('${caterer.logo?.url || caterer.photo?.url || logo}')`
                  }} 
                  alt='caterer logo' 
                />
              </a>

              <a 
                className='flex-1 px-4 leading-tight'
                href={`/${caterer.slug}/`}
                target="_blank"
              >
                <p className='text-md text-black font-bold'>{caterer.name}</p>
                {caterer.cities?.length ? (
                  <p className='text-md text-black font-light'>{cityNameDecorator(caterer.cities[0].display_name)}</p>
                ) : null}
              </a>
              <div className='leading-tight'>
                {caterer.caterer_stat?.total_reviews && caterer.caterer_stat?.average_rating ? (
                  <p className='text-md text-black font-bold'>
                    {caterer.caterer_stat?.average_rating.toFixed(1)}
                    &nbsp;
                    <Star size={12} className='text-yellow inline' fill='#E8C500'/>
                  </p>
                ) : null} 
                {caterer.caterer_stat?.total_bookings && caterer.caterer_stat?.total_bookings > 0 ? (
                  <p className='text-md font-light'>
                    <span className='font-bold text-black'>{caterer.caterer_stat.total_bookings}</span> bookings
                  </p>
                ) : null}
              </div>
            </div>

            {/* Card Body */}
            <div className="flex flex-1 flex-col">
              {caterer.tags?.length ? (
                <div className='mb-4'>
                  {caterer.tags.map((tag) => (    
                    <span 
                      className={[
                        'inline-block rounded-full px-3 py-1',
                        'text-sm  mr-2 mb-2',
                        lead.favorite_cuisine_id == tag.id ? 'bg-gray-600 text-gray-200' : 'bg-gray-200 text-gray-900',
                      ]} 
                      key={tag.id}
                    >
                      {tag.name}
                    </span>
                  ))}
                </div>
              ) : null}
              
              <a 
                className={[
                  'flex flex-1 flex-col justify-end block overflow-hidden',
                ]}
                href={`/${caterer.slug}/`}
                target="_blank"
              >
                <img 
                  className='bg-cover h-0 w-full bg-center border border-gray-400 rounded-md'
                  style={{
                    paddingTop:'30%', 
                    backgroundImage: `url('${caterer.default_package_photo?.url || caterer.photo?.url || caterer.photos[1]?.url || logo}')`,
                  }} 
                  alt='placeholder' 
                />
              </a>
            </div>

            {/* Card Footer */}
            <div className='mt-4'>
              <button 
                className={[
                  'btn rounded-full border-2 px-4 py-1',
                  (requestedCatererIds?.includes(caterer.id)) ? 'btn-blue btn-outline text-white' :'btn-white text-black' 
                ]}
                onClick={() => !requestedCatererIds?.includes(caterer.id) && addRequestedCatererToLead(lead, caterer)}
                children={requestedCatererIds?.includes(caterer.id) ? 'Quote Requested' : 'Request a Quote'}
              
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
